export const DEFAULT_MAX_FILE_SIZE = 1024 * 1024 * 2;

export const DEFAULT_MAX_FILES = 5;

export const DOCUMENTS_DATE_FORMAT = 'MM/dd/yyyy';

export const CHUNKED_UPLOAD_SESSION_TTL_MS = 24 * 60 * 60 * 1000;
